import { render, staticRenderFns } from "./DateTimeDisplay.vue?vue&type=template&id=8fe5920e&"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports